module.exports = __webpack_public_path__ + "img/logo3@2x.90846025.png";